import { createFileRoute, redirect } from '@tanstack/react-router';
import {
  reportSearchFromLegacyCallReport,
  type LegacyCallReportSearch,
} from '@/components/calls/report/legacyCallReportSearch';

/**
 * The Call Report moved into Call Logs → Reports, which now covers everything
 * it showed. The report is still there, so this address must still work:
 * bookmarks, links pasted into chat and command-palette history all point here.
 * The route stays as a redirect and carries the period across where the two
 * pages agree on what it means.
 */
export const Route = createFileRoute('/_dashboard/dashboard/reporting/calls')({
  validateSearch: (search: Record<string, unknown>): LegacyCallReportSearch => ({
    range: typeof search.range === 'string' ? search.range : undefined,
    from: typeof search.from === 'string' ? search.from : undefined,
    to: typeof search.to === 'string' ? search.to : undefined,
  }),
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/dashboard/calllogs/reports',
      search: reportSearchFromLegacyCallReport(search),
      // The old address is a forwarding address, not a stop on the way: going
      // back from the report should leave the app, not bounce through here.
      replace: true,
    });
  },
});
